import { Grid, Row, Space, Typography } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import LineItemImage from 'app/components/Core/LineItem/Image'
import MachineActions from 'app/components/Core/LineItem/Machine/Actions'
import Status from 'app/components/Core/LineItem/Status'
import DateCell from 'app/components/Core/LineItem/Table/DateCell'
import PriceCell from 'app/components/Core/LineItem/Table/PriceCell'
import QuantityWithUnitCell from 'app/components/Core/LineItem/Table/QuantityWithUnitCell'
import SubItemList from 'app/components/Core/SubItem/List'
import KInfoRow from 'app/components/Modules/DataDisplay/KInfoRow'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import { uniq } from 'lodash'

const { Title } = Typography

export default function MachineHeader({ member }: MemberProps<ILineItem>) {
  const { sm } = Grid.useBreakpoint()

  if (!member) return null

  const [name, category_segment] = uniq([member.name, member.categorySegment?.name])
  const freeItems = member.subItems?.filter((item) => item.freeAttachment)

  return (
    <Row gutter={[12, 12]} wrap={!sm}>
      <KCol flex="none" className="pr-4">
        <LineItemImage member={member} props={{ height: 150, width: 150 }} />
      </KCol>
      <KCol flex="auto">
        {/* Info */}
        <Row gutter={[12, 12]}>
          <KCol flex="auto">
            <Title level={3}>
              {name} <Status member={member} props={{ className: 'ml-2' }} />
            </Title>
            <Space direction="vertical" className="full-width">
              {category_segment && <p className="text-muted">{category_segment}</p>}
              <p>
                <SubItemList collection={freeItems} props={{ className: 'text-base' }} />
              </p>

              <MachineAttributes member={member} />
            </Space>
          </KCol>
          <KCol flex="none">
            <MachineActions member={member} />
          </KCol>
        </Row>
      </KCol>
    </Row>
  )
}

function MachineAttributes({ member }: MemberProps<ILineItem>) {
  return (
    <Row gutter={[12, 12]}>
      <KCol span={8}>
        <KInfoRow
          recordType={RecordType.line_item}
          attribute="period"
          value={<DateCell member={member} />}
        />
      </KCol>
      <KCol span={5}>
        <KInfoRow
          recordType={RecordType.line_item}
          attribute="quantity_unit"
          value={<QuantityWithUnitCell member={member} />}
        />
      </KCol>
      <KCol span={5}>
        <KInfoRow
          recordType={RecordType.line_item}
          attribute="unit_price"
          value={<PriceCell member={member} />}
        />
      </KCol>
      <KCol span={6}>
        <KInfoRow
          recordType={RecordType.line_item}
          attribute="total"
          value={<PriceCell member={member} props={{ attribute: 'total' }} />}
        />
      </KCol>
      <KCol span={24}>
        <KInfoRow
          recordType={RecordType.machine}
          attribute="annotation"
          value={member.annotation}
        />
      </KCol>
    </Row>
  )
}
